(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('modelProcessingWorkflow', modelProcessingWorkflow);

    modelProcessingWorkflow.$inject = ['$q', '$log', 'directUploadFileService', 'modelService', 'modelProcessingService', 'processStatusChecker',
        'pricingService', 'modelProcessingErrorHandler', 'uploadedModelsService'];

    function modelProcessingWorkflow($q, $log, directUploadFileService, modelService, modelProcessingService, processStatusChecker, pricingService,
        modelProcessingErrorHandler, uploadedModelsService) {

        var defaultSettings = {
            statusPollingIntervalMs: 1000
        };

        function instance(model, customSettings) {
            this.name = null;
            this.settings = angular.extend({}, defaultSettings, customSettings);

            this.model = model || {};
            this.model.state = "Initial";
            this.model.uploadingFilePercentage = null;
            this.model.issue = null;
        }

        instance.prototype = {
            processFile: processFile,
            processModel: processModel
        };

        return {
            Instance: instance
        };

        // -------------------------------------------------------------------------------------

        function processFile(file, units, productTemplateId, canceler) {
            var self = this;
            self.name = file.name;
            self.model.units = units;
            self.model.productTemplateId = productTemplateId;

            return runProcess.call(self, file, canceler);
        }

        function processModel(modelId, canceler) {
            var self = this;
            self.name = modelId;
            self.model.id = modelId;

            return runProcess.call(self, null, canceler);
        }

        function runProcess(file, canceler) {
            var self = this;
            $log.debug('Run model processing workflow; name: ' + self.name);

            var tasks =
            [
                uploadFile,
                createModel,
                getModelInfo,
                processBadModel,
                waitProcessingResult,
                getModelInfo,
                checkProcessingResult
            ];

            self.model.issue = null;

            var flow = $q.resolve(file);
            _.each(tasks, function (task) {
                flow = flow.then(function (result) {
                    return task.call(self, result, canceler);
                });
            });

            flow = flow.finally(function () {
                $log.debug('FINISHED model processing workflow; name: ' + self.name);

                self.model.state = 'Complete';

                return self.model;
            });

            flow = flow.catch(handleException.bind(self));

            return flow;
        }

        // ------------------------------------------------------------------------------------

        function handleException(reason) {
            $log.debug("Workflow stopped. Reason: ", reason);
            var self = this;

            if (reason === 'CANCELED') {
                self.model.state = 'Canceled';
            } else {
                self.model.issue = modelProcessingErrorHandler.handle(self.model, reason);
            }

            return $q.reject(reason);
        }

        // ############################################ Tasks ############################################

        // ------------------------------------------ uploadFile ------------------------------------------
        function uploadFile(file, canceler) {
            var self = this;

            if (file) {
                $log.debug('uploadFile');
                self.model.state = 'FileUploading';

                return directUploadFileService.uploadFile(file, canceler)
                    .then(fileUploaded.bind(self), null, notifyFileUploadProgress.bind(self));
            }

            return $q.resolve(null);
        }

        function fileUploaded(uploadedFile) {
            $log.debug("file uploaded ", uploadedFile);

            return uploadedFile;
        }

        function notifyFileUploadProgress(percentages) {
            this.model.uploadingFilePercentage = percentages;
        }

        // ------------------------------------------ createModel ------------------------------------------

        function createModel(uploadedFile, canceler) {
            var self = this;

            if (self.model.id) {
                return $q.resolve(self.model.id);
            }

            if (uploadedFile) {
                $log.debug("createModel for fileName: " + uploadedFile.fileName);

                self.model.state = 'ModelCreating';

                return modelService.createModel(uploadedFile.fileId, uploadedFile.fileName, self.model.units, self.model.productTemplateId, canceler)
                    .then(function (modelId) {
                        modelCreated.call(self, modelId, canceler);
                    });
            }

            return $q.resolve(null);
        }

        function modelCreated(modelId, canceler) {
            $log.debug("modelCreated modelId =", modelId);

            uploadedModelsService.registerModel(modelId);

            this.model.id = modelId;

            return modelId;
        }

        // ------------------------------------------ getModelInfo ------------------------------------------

        function getModelInfo(data, canceler) {
            var self = this;

            if (!self.model.id) {
                return $q.reject("Model id does not exists.");
            }

            if (self.model.result && !self.model.result.isUnknown()) {
                return $q.resolve(self.model);
            }

            return getModelInfoWithoutConditions.call(self, canceler);
        }

        function getModelInfoWithoutConditions(canceler) {
            var self = this;

            self.model.state = 'GettingModelInfo';
            return modelService.getModelInfo(self.model.id, canceler)
                .then(function (modelInfo) {
                    $log.debug("getModelInfo ", modelInfo);

                    angular.merge(self.model, modelInfo);

                    return self.model;
                });
        }

        // ---------------------------------------- processBadModel -------------------------------------

        function processBadModel(model, canceler) {
            var self = this;
            var modelId = self.model.id;

            if (!modelId) {
                return $q.reject("Model id does not exists.");
            }

            if (model.status.isDone() && (model.result.isFailed() || model.result.isUnknown())) {
                $log.debug("runProcessForBadModel started for modelId = " + modelId);

                self.model.state = 'ModelCreating';
                model.status = angular.undefined;
                model.result = angular.undefined;

                return modelProcessingService.runProcessForBadModel(modelId, canceler)
                    .then(function () {
                        $log.debug("runProcessForBadModel end for modelId = " + modelId);
                        return getModelInfoWithoutConditions.call(self, canceler);
                    });
            }

            return $q.resolve(model);
        }

        // ---------------------------------------- waitProcessingResult -------------------------------------

        function waitProcessingResult(model, canceler) {
            if (angular.isUndefined(model.status)) {
                return $q.reject('Unknown model status');
            }

            if (model.status.isDone()) {
                return $q.resolve(model.id);
            }

            this.model.state = 'WaitProcessingResult';

            canceler.then(function () {
                var status = model.status;
                if (status && status.isDone()) {
                    return;
                }

                $log.debug("abortProcessing on server side modelId = ", model.id);
                modelProcessingService.abortProcessing(model.id);
            });

            return waitDoneStatusProcessing.call(this, model.id, canceler);
        }

        function waitDoneStatusProcessing(modelId, canceler) {
            if (angular.isUndefined(modelId)) {
                return $q.reject('Model id does not specified');
            }

            $log.debug("waitDoneStatusProcessing modelId = " + modelId);

            var checkerPromise = processStatusChecker.run(modelId, this.settings.statusPollingIntervalMs, canceler);
            checkerPromise.finally(null, statusChanged.bind(this));

            return checkerPromise;
        }

        function statusChanged(newStatus) {
            this.model.status = newStatus;
        }

        // ---------------------------------------- checkProcessingResult -------------------------------------

        function checkProcessingResult(model) {
            $log.debug('checkProcessingResult modelId = ' + model.id);

            var result = model ? model.result : null;
            if (!result) {
                return $q.reject('Check processing result failed. No results.');
            }

            if (result.isInvalid()) {
                return $q.reject('Invalid model');
            }

            if (result.isAborted()) {
                return $q.reject('Aborted model');
            }

            if (result.isFailed() || result.isUnknown()) {
                return $q.reject('Processing failed');
            }

            if (model.isNeedToApproveRepairModel()) {
                return $q.reject('Not accepted V3 results');
            }

            return $q.resolve(model);
        }
    }
}());